import { useEffect } from 'react';

const useLedDisplay = () => {
    useEffect(() => {
        // Mock hook
    }, []);
    
    return {
        clearDisplay: () => {}
    };
};

export default useLedDisplay;
